import { Component, OnInit } from '@angular/core';

import { PageInfoService } from '../../layouts/page-info.service';
import { NavSectionEnum } from '../../layouts/nav-section.enum';

/**
 * This component is the not found page for the application.
 */
@Component({
	selector: 'cc-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.css'],
})
export class PageNotFoundComponent implements OnInit {

// #region [ Constructor ]

	constructor(
		private _PageInfoService: PageInfoService
	) { }

// #region [ Event Handlers ]

	public ngOnInit(): void {
		this._PageInfoService.CurrentSection = NavSectionEnum.None;
	}

}